import { getContentModule } from '@/components/content/Content'
import SectionModule, {
  SectionValueProps,
} from '@/components/section-composition/section'
import { CONTENT_TYPE } from 'contentful/types/contentful-modules'
import { RootSectionReactTypes } from '@/components/content/contentMapper'
import { ReactElement } from 'react'

export const ContentWrapper = ({
  layout,
  contentType,
  content,
}: {
  contentType: CONTENT_TYPE | 'page-title-low.experiment'
  content: RootSectionReactTypes
  layout: {
    contentfulId: string
    section?: SectionValueProps
    handlesLayout?: boolean
  }
}): ReactElement => {
  const resolvedContentModule = getContentModule({ contentType, content })

  // ensure that if no localized content is available, we don't show the section
  if (!resolvedContentModule) {
    return null
  }
  return (
    <SectionModule
      section={layout.section}
      handlesLayout={layout.handlesLayout}
    >
      {resolvedContentModule}
    </SectionModule>
  )
}
